export const COL_NAME_FIELD : string = 'webapp_interface_store_c001_fields'
export const COL_NAME_TEMPLATE  : string= 'webapp_interface_store_c001_templates'
export const COL_NAME_CONTENT : string = 'webapp_interface_store_c001_contents'

export const ID_CONTENT_WEBSITE_HOME_TEMPLATE : string = 'website-content'
export const ID_CONTENT_APP_HOME_TEMPLATE : string = 'app-content'